export default function MatchDetailModal({ match, onClose }) {
  if (!match) return null;

  const firstGame = match.games?.[0];

  const blueTeam = firstGame?.blue_team;
  const redTeam = firstGame?.red_team;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-matchup" onClick={(e) => e.stopPropagation()}>
        <img src={`/teams/${blueTeam?.team_logo}`} alt={blueTeam?.name} className="match-modal-bg-team-right" />
        <img src={`/teams/${redTeam?.team_logo}`} alt={redTeam?.name} className="match-modal-bg-team-left" />
        <div className="modal-actions" style={{ marginTop: "0", zIndex: "10", position: "relative" }}>
          <button onClick={onClose} className="cancel">
            Close
          </button>
        </div>
        <h2 style={{ textAlign: "center", color: "white" }}>
          {blueTeam?.name} vs {redTeam?.name} | BO{match.best_of}
        </h2>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            paddingRight: "20px",
            position: "relative",
            zIndex: "99",
            justifyContent: "center",
          }}>
          <a href={match.watch_yt} target="_blank" rel="noopener noreferrer" className="yt-link">
            <img src="/yt-icon.svg" alt="Youtube Watch Button" className="yt-icon" style={{ height: "auto", width: "58px" }} />
          </a>
          <a href={match.watch_twitch} target="_blank" rel="noopener noreferrer" className="twitch-link">
            <img src="/twitch.svg" alt="Twitch Watch Button" className="twitch-icon" style={{ height: "auto", width: "58px" }} />
          </a>
        </div>
        <div className="modal-teams-matchup">
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img src={`/teams/${blueTeam?.team_logo}`} alt="n" />
          </div>
          <div>
            <img src="/vs-icon.svg" alt="Versus Icon" className="versus-icon" />
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img src={`/teams/${redTeam?.team_logo}`} alt="n" />
          </div>
        </div>
      </div>
    </div>
  );
}
